<template>
  <validated-form
    ref="form"
    auto-focus
    form-id="addEditAccountTagForm"
    @valid-submit="handleSubmit"
  >
    <modal-card :title="modalTitle">
      <validated-text-input
        v-model="form.name"
        :has-icon="false"
        label="Name"
        name="name"
        maxlength="50"
        :rules="{
          required: true,
          uniqueStringCaseInsensitive: existingUserAttributeNames
        }"
        type="text"
      />

      <validated-text-input
        v-model="form.description"
        :has-icon="false"
        label="Description"
        name="description"
        maxlength="255"
        type="textarea"
        rows="3"
      />

      <template #footer>
        <div class="buttons all-bold">
          <b-button
            rounded
            @click="$_confirmCloseModal({ programmatic: true })"
          >
            Cancel
          </b-button>
          <b-button
            v-tabbable
            rounded
            native-type="submit"
            type="is-primary"
            :loading="isSubmitting"
            :disabled="isSubmitting"
          >
            Save
          </b-button>
        </div>
      </template>
    </modal-card>
  </validated-form>
</template>

<script>
  import merchantMixin from '@/mixins/merchant';
  import confirmModalCloseMixin from '@/mixins/confirm-modal-close';

  import UserAttribute from '@/store/classes/UserAttribute';

  export default {
    name: 'AddEditAccountTagModal',

    mixins: [merchantMixin, confirmModalCloseMixin],

    props: {
      userAttribute: {
        type: Object,
        default: () => ({})
      }
    },

    data() {
      return {
        form: new UserAttribute()
      };
    },

    computed: {
      isNewUserAttribute() {
        return !this.userAttribute.id;
      },

      modalTitle() {
        return this.isNewUserAttribute ? 'Create Account Tag' : `Update ${this.userAttribute.name}`;
      },

      existingUserAttributeNames() {
        return UserAttribute.query()
          .where('merchantId', this.$_selectedMerchantId)
          .get()
          .map(attribute => attribute.name)
          .filter(attributeName => attributeName !== this.userAttribute.name);
      },

      isSubmitting() {
        return UserAttribute.$state().creating || UserAttribute.$state().updating;
      }
    },

    created() {
      this.form = this.$clone(this.userAttribute);
    },

    methods: {
      handleSubmit() {
        if (this.isNewUserAttribute) {
          this.createUserAttribute();
        }
        else {
          this.updateUserAttribute();
        }
      },

      async createUserAttribute() {
        try {
          await UserAttribute.createAttribute(this.form);

          this.$_onRequestSuccess({
            toastOptions: {
              message: `Successfully created account tag <b>${this.form.name}</b>!`
            },
            options: {
              closeParent: true
            }
          });
        }
        catch (error) {
          this.$_onRequestError({
            error,
            toastOptions: {
              message: `Unable to create account tag <b>${this.form.name}</b>`
            }
          });
        }
      },

      async updateUserAttribute() {
        try {
          await UserAttribute.updateAttribute(this.form);

          this.$_onRequestSuccess({
            toastOptions: {
              message: `Successfully updated account tag <b>${this.form.name}</b>!`
            },
            options: {
              closeParent: true
            }
          });
        }
        catch (error) {
          this.$_onRequestError({
            error,
            toastOptions: {
              message: `Unable to update account tag <b>${this.form.name}</b>`
            }
          });
        }
      }
    }
  };
</script>

<style lang="sass" scoped>
  .modal-card
    max-width: 500px
</style>
